// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"262ced8f","312":"9751e1a2","453":"3b7adf13","484":"6622bed8","640":"4eec5744"}[chunkId] + ".chunk.js";
};